import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { conversationApi } from '@formosa/shared/api/im';
import '../../styles/chat.css';

/** /chat/groups — GROUP conversations + create entry */
export default function GroupsPage() {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    setError('');
    conversationApi
      .listMine()
      .then((list) => {
        const rows = (Array.isArray(list) ? list : []).filter(
          (c) => c.conversationType === 'GROUP' || c.conversationType === 'BUSINESS_GROUP'
        );
        setGroups(rows);
      })
      .catch((e) => setError(e?.message || '載入失敗'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="chat-social-page">
      <header className="chat-social-page__header">
        <Link to="/chat" className="chat-link-btn">
          ← 聊天
        </Link>
        <h1>群組</h1>
        <div className="chat-social-page__actions">
          <Link to="/chat/groups/new">建立群組</Link>
          <button type="button" onClick={load}>
            重新整理
          </button>
        </div>
      </header>

      {error ? <p className="chat-social-page__error">{error}</p> : null}
      {loading ? <p>載入中…</p> : null}

      <ul className="chat-social-page__list">
        {groups.map((g) => {
          const id = g.conversationId || g.id;
          const count = (g.participantMemberIds || []).length;
          return (
            <li key={id}>
              <button
                type="button"
                className="chat-social-page__row"
                onClick={() => navigate(`/chat/${id}`)}
              >
                <span className="chat-social-page__name">{g.title || '未命名群組'}</span>
                <span className="chat-social-page__meta">
                  {count ? `${count} 人` : g.conversationType}
                  {g.lastMessagePreview ? ` · ${g.lastMessagePreview}` : ''}
                </span>
              </button>
              <Link to={`/chat/groups/${id}/add`} className="chat-link-btn">
                加人
              </Link>
            </li>
          );
        })}
      </ul>
      {!loading && !groups.length ? (
        <p className="chat-social-page__empty">尚無群組，點「建立群組」開始。</p>
      ) : null}
    </div>
  );
}
